import React from 'react';

export const ParticipantsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="8.26334"
      y="3.30411"
      width="7.39111"
      height="7.99463"
      rx="3.69556"
      stroke="#27B0E0"
      strokeWidth="1.70564"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4131 8.05577C15.4382 7.84954 15.4511 7.63925 15.4511 7.42573C15.4511 6.80706 15.3425 6.21543 15.1445 5.67134C15.7306 5.24735 16.4389 4.99948 17.2017 4.99948C19.2212 4.99948 20.8584 6.73677 20.8584 8.87983C20.8584 11.0229 19.2212 12.7602 17.2017 12.7602C15.879 12.7602 14.7204 12.015 14.0782 10.8986C14.616 10.3392 15.0244 9.63891 15.2508 8.8537C15.2507 8.86239 15.2507 8.8711 15.2507 8.87983C15.2507 10.01 16.1163 10.9414 17.2017 10.9414C18.2871 10.9414 19.1528 10.01 19.1528 8.87983C19.1528 7.74961 18.2871 6.81828 17.2017 6.81828C16.3969 6.81828 15.713 7.3303 15.4131 8.05577Z"
      fill="#27B0E0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.58705 8.05577C8.56197 7.84954 8.54903 7.63925 8.54903 7.42573C8.54903 6.80706 8.65763 6.21543 8.85562 5.67134C8.26953 5.24735 7.56125 4.99948 6.79841 4.99948C4.77888 4.99948 3.14172 6.73677 3.14172 8.87983C3.14172 11.0229 4.77888 12.7602 6.79841 12.7602C8.1211 12.7602 9.27975 12.015 9.92188 10.8986C9.3841 10.3392 8.97577 9.63891 8.74931 8.8537C8.74941 8.86239 8.74946 8.8711 8.74946 8.87983C8.74946 10.01 7.88379 10.9414 6.79841 10.9414C5.71304 10.9414 4.84736 10.01 4.84736 8.87983C4.84736 7.74961 5.71304 6.81828 6.79841 6.81828C7.60319 6.81828 8.28717 7.3303 8.58705 8.05577Z"
      fill="#27B0E0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.65525 19.2526C3.52686 17.3613 4.78107 13.6673 7.5516 13.6673H16.3669C19.1374 13.6673 20.3916 17.3613 18.2633 19.2526C16.5936 20.7363 14.4891 21.5488 12.3157 21.5488H11.6028C9.42942 21.5488 7.32486 20.7363 5.65525 19.2526ZM7.5516 15.4861C6.37635 15.4861 5.84432 17.0531 6.74717 17.8554C8.11025 19.0667 9.82843 19.73 11.6028 19.73H12.3157C14.0901 19.73 15.8082 19.0667 17.1713 17.8554C18.0742 17.0531 17.5422 15.4861 16.3669 15.4861H7.5516Z"
      fill="#27B0E0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.90479 20.1375C6.74151 20.1491 6.57749 20.1549 6.41297 20.1549H5.84259C4.10389 20.1549 2.42021 19.5049 1.08453 18.3179C-0.618114 16.8048 0.38525 13.8497 2.60163 13.8497H6.61413C5.91082 14.1159 5.36752 14.6509 5.03523 15.3048H2.60163C1.66146 15.3048 1.23584 16.5583 1.95809 17.2001C2.88738 18.0259 4.023 18.5334 5.21692 18.6654C5.36023 18.8744 5.53285 19.0718 5.7364 19.2527C6.10588 19.581 6.49667 19.8765 6.90479 20.1375Z"
      fill="#27B0E0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0953 20.1375C17.2586 20.1491 17.4226 20.1549 17.5871 20.1549H18.1575C19.8962 20.1549 21.5799 19.5049 22.9156 18.3179C24.6182 16.8048 23.6149 13.8497 21.3985 13.8497H17.386C18.0893 14.1159 18.6326 14.6509 18.9649 15.3048H21.3985C22.3387 15.3048 22.7643 16.5583 22.042 17.2001C21.1127 18.0259 19.9771 18.5334 18.7832 18.6654C18.6399 18.8744 18.4673 19.0718 18.2637 19.2527C17.8942 19.581 17.5035 19.8765 17.0953 20.1375Z"
      fill="#27B0E0"
    />
  </svg>
);
